/**
 * Classificação de texto livre em opções (menus do chatbot, roteamento por
 * categoria). Estratégia híbrida: o classificador local (Laya) decide quando
 * está seguro; abaixo do limiar devolve 'unknown' e a decisão vai para o LLM.
 *
 * Cada chamada vira uma linha em ia_requisicao com este `output`, que é o que
 * a tela "Classificador de texto" lê para mostrar hits (Laya decidiu) e
 * misses (foi para o LLM).
 */

export type ClassificacaoOrigem = "laya" | "llm";

export const ROTULOS_ORIGEM_CLASSIFICACAO: Record<ClassificacaoOrigem, string> = {
  laya: "Local",
  llm: "LLM",
};

export type ClassificacaoLayaOutput = {
  /** Opção escolhida, ou 'unknown' abaixo do limiar. */
  result: string;
  /** Opção com maior probabilidade, mesmo quando result é 'unknown'. Serve para medir se o Laya teria acertado. */
  melhor_opcao: string;
  pontuacao: number;
  confianca: number;
  probabilidades: Record<string, number>;
};

export type ClassificacaoOutput = {
  /** Resultado usado pelo fluxo. */
  result: string;
  origem: ClassificacaoOrigem;
  opcoes: string[];
  criterio: string;
  /** Nulo quando o classificador local falhou (indisponível, erro). */
  laya: ClassificacaoLayaOutput | null;
  /** Presente só quando houve fallback. */
  llm: { result: string } | null;
};

export type ClassificacaoDto = {
  id: number;
  data_criacao: string;
  chat_id: number | null;
  input_anonimizado: string;
  output: ClassificacaoOutput;
};

export type ClassificacaoResumo = {
  total: number;
  /** Laya decidiu. */
  laya: number;
  /** Caiu no LLM. */
  llm: number;
  /** Laya falhou (sem resposta) — subconjunto de `llm`. */
  laya_indisponivel: number;
  /** Nos fallbacks com Laya respondendo: quantos em que a melhor opção do Laya coincidiu com o LLM. */
  concordancia: { total: number; iguais: number };
};
